import {ensureHierarchy, mergeTo} from '#core/utils/config-utils.js';
import {buildIntentsFromConfig} from '#core/utils/intent-factory.js';

import {AbstractFeature, allFeatures} from '#core/application/abstract-feature.js';
import {Localization} from '#core/localization.js';
import {ApplicationConfig} from '#core/config/application-config.js';

import SCHEMA from './settings-menu.schema.yaml';

class SettingsMenuFeature extends AbstractFeature {
    get name() {
        return 'Settings Menu';
    }

    get configSchema() {
        return SCHEMA;
    }

    beforeMojitoConfigBuild(mojitoConfig) {
        const configurations = ensureHierarchy(mojitoConfig, 'services.configurations');

        mergeTo(configurations, {
            AZMenu: {
                settingsMenu: {
                    hide: !this.config.showInMobileSideMenu,
                },
            },
            MainNavigationBar: {
                showSettingsButton: this.config.showInDesktopHeader,
            },
            SettingsMenu: {
                language: {
                    hide:
                        !this.config.showLanguageSelector ||
                        Localization.availableLanguages.length <= 1 ||
                        ApplicationConfig.isEmbedded,
                },
                oddsFormat: {
                    hide: !this.config.showOddsFormatSelector,
                },
                timeOffset: {
                    hide: !this.config.showTimeOffsetSelector,
                },
                additionalLinks: {
                    links: buildIntentsFromConfig(this.config.additionalLinks),
                },
            },
        });
        return super.beforeMojitoConfigBuild(mojitoConfig);
    }
}

new SettingsMenuFeature(allFeatures);
